import React, { Component } from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import { SORT_BY, SORT_BY_RU } from './ListSidebar';
import cx from 'classnames';
import translate from "react-i18next/dist/es/translate";

@translate(['sort-by-filter'], {wait:true})
@onClickOutside
class SortByFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      opened: false,
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.toggleOpened = this.toggleOpened.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClickOutside() {
    this.setState({
      opened: false,
    });
  }

  toggleOpened(e) {
    e.preventDefault();

    this.setState({
      opened: !this.state.opened,
    });
  }

  handleClick(e) {
    this.setState({
      opened: false,
    });

    this.props.changeSortBy(e);
  }

  render() {
    const {t} = this.props;
    return (
      <div className={cx('aside__filter__btn__wrap', { openDrop: this.state.opened })}>
        <span onClick={this.toggleOpened} className="aside__filter__btn aside__filter__btn-date">{t('sort-by-filter:' + this.props.sortBy)}</span>
        <div className="aside__filter__drop">
          <ul className="aside__filter__drop__list">
            {
              SORT_BY.map((item, index) => {
                return (
                  <li key={index}><a id={item} onClick={this.handleClick} href="">{t('sort-by-filter:' + item)}</a></li>
                );
              })
            }
          </ul>
        </div>
      </div>
    );
  }
}

SortByFilter.propTypes = {
  changeSortBy: PropTypes.func,
  sortBy: PropTypes.string,
};

export default SortByFilter;



// WEBPACK FOOTER //
// ./src/components/Sidebar/RidesSidebar/SortByFilter.js